import { createSelector } from '@ngrx/store';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getMultipleOrderOnlineState } from '../reducers';

const purchaseOrderMOOState = createSelector(getMultipleOrderOnlineState, (state) => state.purchaseOrder);
const worksheetsState = createSelector(getMultipleOrderOnlineState, (state) => state.shipmentLocationWorksheets);

const selectJobSiteSalesAreas = createSelector(worksheetsState, (state) => _safe(() => state.jobsiteSalesAreas));

const getProductLine = createSelector(worksheetsState, (state) => '0006'); // state.fullSalesAreas.businessLine);

const getJobsiteId = createSelector(
  worksheetsState,
  (state) => state && state.jobsiteSalesAreas && state.jobsiteSalesAreas.jobsiteSalesAreas[0].jobsite.jobsiteId,
);

export const getIsPurchaseOrderValidationRequired = createSelector(selectJobSiteSalesAreas, (state) =>
  _safe(() => _safe(() => state.jobsiteSalesAreas[0].purchaseOrderValidation), false),
);

export const getPurchaseOrderValidationData = createSelector(getProductLine, getJobsiteId, (productLine, jobsiteId) => {
  return {
    productLine: productLine,
    jobsiteId: _safe(() => jobsiteId),
  };
});

export const getValidPOMaskExpressions = createSelector(purchaseOrderMOOState, (state) => {
  return state.validMasks;
});
